import { useEffect, useState } from "react";

/**
 * Creates exactly one object URL per File/Blob and revokes it when the file
 * changes or the component unmounts.
 *
 * Calling `URL.createObjectURL(file)` inline in JSX mints a brand-new URL on
 * every render — the browser re-decodes the (often 8-12MP) camera capture each
 * time and the previous URLs are never released. On yard handhelds that is
 * enough memory/decode pressure to lock the page up.
 */
export function useObjectUrl(file: Blob | null | undefined): string | null {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!file) {
      setUrl(null);
      return;
    }
    const next = URL.createObjectURL(file);
    setUrl(next);
    return () => {
      URL.revokeObjectURL(next);
    };
  }, [file]);

  return url;
}
